module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/stage-icon-c7890ef4c7078fab67a21a5a1abeb2f2.png";